import React from 'react';

const ProfessionalPage = ({ title, children }) => {
  return (
    <div className="professional-page">
      <main className="professional-content">
        <h1>{title}</h1>
        <div className="professional-body">{children}</div>
      </main>
    </div>
  );
};

export default ProfessionalPage;
